import React from 'react'

function Register() {
    return (
        <div>
            register
        </div>
    )
}

export default Register
